import $axios from "../../api";

const PREFIX = "unionweb/promotion";

const state = () => ({
  listLoading: false,
  createLoading: false,
  productDetailLoading: false,
  activeProductsLoading: false,
  detailLoading: false,
  updateLoading: false,
  destroyLoading: false,
  publishLoading: false,

  listSuccess: false,
  createSuccess: false,

  validationErrors: null,
  serverError: null,

  page: 1,
  list: [],

  productDetail: null,
  activeProducts: { data: [], pagination: { current_page: 1, per_page: 20, total: 0, last_page: 1, from: 0, to: 0 } },

  detail: null,
});

const mutations = {

  SET_LIST_LOADING(state, payload) {
    state.listLoading = payload;
  },

  SET_CREATE_LOADING(state, payload) {
    state.createLoading = payload;
  },

  SET_LIST_SUCCESS(state, payload) {
    state.listSuccess = payload;
  },

  SET_CREATE_SUCCESS(state, payload) {
    state.createSuccess = payload;
  },

  SET_VALIDATION_ERRORS(state, payload) {
    state.validationErrors = payload;
  },

  SET_SERVER_ERROR(state, payload) {
    state.serverError = payload;
  },

  SET_LIST(state, payload) {
    state.list = payload || [];
  },

  SET_PRODUCT_DETAIL_LOADING(state, payload) {
    state.productDetailLoading = payload;
  },

  SET_PRODUCT_DETAIL(state, payload) {
    state.productDetail = payload || null;
  },

  SET_ACTIVE_PRODUCTS_LOADING(state, payload) {
    state.activeProductsLoading = payload;
  },

  SET_ACTIVE_PRODUCTS(state, payload) {
    state.activeProducts = payload || {
      data: [],
      pagination: { current_page: 1, per_page: 20, total: 0, last_page: 1, from: 0, to: 0 },
    };
  },

  SET_DETAIL_LOADING(state, payload) {
    state.detailLoading = payload;
  },

  SET_DETAIL(state, payload) {
    state.detail = payload || null;
  },

  SET_UPDATE_LOADING(state, payload) {
    state.updateLoading = payload;
  },

  SET_DESTROY_LOADING(state, payload) {
    state.destroyLoading = payload;
  },

  SET_PUBLISH_LOADING(state, payload) {
    state.publishLoading = payload;
  },

  REMOVE_FROM_LIST(state, id) {
    if (!state.list || !state.list.data) return;
    state.list.data = state.list.data.filter(x => x.id !== id);
    if (state.list.total !== undefined) state.list.total = Math.max(0, state.list.total - 1);
  },

  PATCH_LIST_ITEM(state, payload) {
    if (!state.list || !state.list.data) return;
    const idx = state.list.data.findIndex(x => x.id === payload.id);
    if (idx >= 0) {
      state.list.data.splice(idx, 1, { ...state.list.data[idx], ...payload });
    }
  },

  RESET_CREATE_STATE(state) {
    state.createLoading = false;
    state.createSuccess = false;
    state.validationErrors = null;
    state.serverError = null;
  }

};

const actions = {
  async getList({ commit, state, rootState, dispatch }, query = "") {

    commit("SET_LIST_LOADING", true);
    commit("SET_LIST_SUCCESS", false);
    commit("SET_SERVER_ERROR", null);

    try {

      const page = state.page;
      const view = rootState.Main.view;
      const res = await $axios.get(
        `${PREFIX}/list?page=${page}&view=${view}${query}`
      );
      commit("SET_LIST", res.data?.data);
      commit("SET_LIST_SUCCESS", true);
      return res;

    } catch (error) {

      const response = error?.response;
      commit("SET_SERVER_ERROR", response);
      dispatch("Main/globalSweetAlert", response, { root: true });
      throw error;

    } finally {

      commit("SET_LIST_LOADING", false);
    }
  },
  async create({ commit, dispatch }, payload) {

    commit("RESET_CREATE_STATE");
    commit("SET_CREATE_LOADING", true);

    try {

      const res = await $axios.post(
        `${PREFIX}/create`,
        payload
      );
      commit("SET_CREATE_SUCCESS", true);
      dispatch("Main/globalSuccessSweetAlert",
        res.data?.message || "Promo berhasil dibuat",
        { root: true }
      );
      return res;

    } catch (error) {

      const response = error?.response;
      if (response?.status === 422) {
        commit("SET_VALIDATION_ERRORS", response.data?.errors || null);
      } else {
        commit("SET_SERVER_ERROR", response);
        dispatch("Main/globalSweetAlert", response, { root: true });
      }
      throw error;

    } finally {
      commit("SET_CREATE_LOADING", false);
    }
  },
  async getProductPromoDetail({ commit, dispatch }, sku) {

    commit("SET_PRODUCT_DETAIL_LOADING", true);
    commit("SET_PRODUCT_DETAIL", null);

    try {

      const res = await $axios.get(
        `${PREFIX}/product/${encodeURIComponent(sku)}/detail`
      );
      commit("SET_PRODUCT_DETAIL", res.data?.data);
      return res;

    } catch (error) {

      const response = error?.response;
      commit("SET_SERVER_ERROR", response);
      // 404 sengaja tidak di-globalSweetAlert — caller handle inline.
      if (response?.status !== 404) {
        dispatch("Main/globalSweetAlert", response, { root: true });
      }
      throw error;

    } finally {

      commit("SET_PRODUCT_DETAIL_LOADING", false);
    }
  },
  async getActivePromoProducts({ commit, dispatch }, params = {}) {

    commit("SET_ACTIVE_PRODUCTS_LOADING", true);

    try {

      const query = Object.entries(params)
        .filter(([, v]) => v !== undefined && v !== null && v !== "")
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join("&");

      const res = await $axios.get(
        `${PREFIX}/active-products${query ? `?${query}` : ""}`
      );
      commit("SET_ACTIVE_PRODUCTS", {
        data: res.data?.data || [],
        pagination: res.data?.pagination || {},
      });
      return res;

    } catch (error) {

      const response = error?.response;
      commit("SET_SERVER_ERROR", response);
      dispatch("Main/globalSweetAlert", response, { root: true });
      throw error;

    } finally {

      commit("SET_ACTIVE_PRODUCTS_LOADING", false);
    }
  },

  async getDetail({ commit, dispatch }, id) {

    commit("SET_DETAIL_LOADING", true);
    commit("SET_DETAIL", null);

    try {
      const res = await $axios.get(`${PREFIX}/${id}`);
      commit("SET_DETAIL", res.data?.data);
      return res;
    } catch (error) {
      const response = error?.response;
      commit("SET_SERVER_ERROR", response);
      dispatch("Main/globalSweetAlert", response, { root: true });
      throw error;
    } finally {
      commit("SET_DETAIL_LOADING", false);
    }
  },

  async update({ commit, dispatch }, { id, payload }) {

    commit("RESET_CREATE_STATE");
    commit("SET_UPDATE_LOADING", true);

    try {
      const res = await $axios.put(`${PREFIX}/${id}`, payload);
      dispatch("Main/globalSuccessSweetAlert",
        res.data?.message || "Promo berhasil diupdate",
        { root: true }
      );
      return res;
    } catch (error) {
      const response = error?.response;
      if (response?.status === 422) {
        commit("SET_VALIDATION_ERRORS", response.data?.errors || null);
      } else {
        commit("SET_SERVER_ERROR", response);
        dispatch("Main/globalSweetAlert", response, { root: true });
      }
      throw error;
    } finally {
      commit("SET_UPDATE_LOADING", false);
    }
  },

  async destroy({ commit, dispatch }, id) {

    commit("SET_DESTROY_LOADING", true);

    try {
      const res = await $axios.delete(`${PREFIX}/${id}`);
      commit("REMOVE_FROM_LIST", id);
      dispatch("Main/globalSuccessSweetAlert",
        res.data?.message || "Promo dihapus",
        { root: true }
      );
      return res;
    } catch (error) {
      const response = error?.response;
      commit("SET_SERVER_ERROR", response);
      dispatch("Main/globalSweetAlert", response, { root: true });
      throw error;
    } finally {
      commit("SET_DESTROY_LOADING", false);
    }
  },

  async publish({ commit, dispatch }, id) {

    commit("SET_PUBLISH_LOADING", true);

    try {
      const res = await $axios.post(`${PREFIX}/${id}/publish`);
      commit("PATCH_LIST_ITEM", { id, is_publish: 1 });
      dispatch("Main/globalSuccessSweetAlert",
        res.data?.message || "Promo dipublish",
        { root: true }
      );
      return res;
    } catch (error) {
      const response = error?.response;
      commit("SET_SERVER_ERROR", response);
      dispatch("Main/globalSweetAlert", response, { root: true });
      throw error;
    } finally {
      commit("SET_PUBLISH_LOADING", false);
    }
  },

  async unpublish({ commit, dispatch }, id) {

    commit("SET_PUBLISH_LOADING", true);

    try {
      const res = await $axios.post(`${PREFIX}/${id}/unpublish`);
      commit("PATCH_LIST_ITEM", { id, is_publish: 0 });
      dispatch("Main/globalSuccessSweetAlert",
        res.data?.message || "Promo di-unpublish",
        { root: true }
      );
      return res;
    } catch (error) {
      const response = error?.response;
      commit("SET_SERVER_ERROR", response);
      dispatch("Main/globalSweetAlert", response, { root: true });
      throw error;
    } finally {
      commit("SET_PUBLISH_LOADING", false);
    }
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};